import { type FC } from 'react';
import { useUnit } from 'effector-react';
import { Control } from '@effector-form';
import i18n from '@shared/config/i18n';
import { FiltersTemplate } from '@shared/ui/organisms/filters-template';
import {
  filtersForm,
  $isDefaultFilterValues,
  changedFilterVisibility,
} from '../../models';
import * as Styled from './styled';

const paymentOptions = [
  { id: '0', label: i18n.t('Frees') },
  { id: '1', label: i18n.t('Paids') },
];

const stuffWriteOptions = [
  { id: '0', label: i18n.t('Need') },
  { id: '1', label: i18n.t('NotNeed') },
];

const slaOptions = [
  {
    id: '1',
    label: i18n.t('LateApplications'),
  },
  {
    id: '0',
    label: i18n.t('IsNotLateApplications'),
  },
];

const rateOptions = [
  {
    id: '1',
    label: '1',
  },
  {
    id: '2',
    label: '2',
  },
  {
    id: '3',
    label: '3',
  },
  {
    id: '4',
    label: '4',
  },
  {
    id: '5',
    label: '5',
  },
];

export const Filters: FC = () => {
  const isDefaultFilterValues = useUnit($isDefaultFilterValues);
  const { values } = useUnit(filtersForm);

  const handleClose = () => changedFilterVisibility(false);

  return (
    <FiltersTemplate
      onClose={handleClose}
      form={filtersForm}
      isDefaultFilterValues={isDefaultFilterValues}
    >
      <Control.DateRangePicker
        label={i18n.t('DateOfCreation')}
        name="periodOfCreation"
        form={filtersForm}
      />
      <Control.TicketStatus
        label={i18n.t('RequestStatus')}
        name="statuses"
        form={filtersForm}
        multiple
      />
      <Styled.Checkboxes>
        <Control.Checkbox
          label={i18n.t('TransferredToTehzor')}
          name="isTehzor"
          form={filtersForm}
        />
        <Control.Checkbox
          label={i18n.t('OnTheTechnicalSupportSide')}
          name="isSupportActive"
          form={filtersForm}
        />
      </Styled.Checkboxes>
      <Control.TicketPriority
        label={i18n.t('ExecutionPriority')}
        name="priorities"
        form={filtersForm}
        multiple
      />
      <Control.TicketClass
        label={i18n.t('RequestClass')}
        name="classes"
        form={filtersForm}
        multiple
      />
      <Control.TicketTypesTree
        label={i18n.t('RequestType')}
        name="types"
        form={filtersForm}
        withAcrchived
        isSearchable
        isCollapsible
      />
      <Control.Select
        label={i18n.t('Payment')}
        name="payment"
        form={filtersForm}
        options={paymentOptions}
      />
      {typeof values.payment === 'string' && Number(values.payment) === 1 && (
        <Control.InvoiceStatus
          label={i18n.t('PaymentStatus')}
          name="invoiceStatus"
          form={filtersForm}
        />
      )}
      <Control.Complexes label={i18n.t('complex')} name="objects" form={filtersForm} />
      <Control.BuildingsFilter
        label={i18n.t('building')}
        name="houses"
        form={filtersForm}
        complexes={values.objects}
      />
      <Control.Apartment
        label={i18n.t('Label.flat')}
        name="apartments"
        form={filtersForm}
        buildingIds={values.houses.map((house) => house.id)}
        multiple
      />
      <Control.Properties
        label={i18n.t('room')}
        name="property"
        form={filtersForm}
        buildings={values.houses}
      />
      <Control.PeopleSearch
        label={i18n.t('Declarant')}
        name="initiators"
        form={filtersForm}
        multiple
        helperText={i18n.t('EnterAtLeastOneLetter')}
      />
      <Control.Select
        label={i18n.t('WriteOffRequired')}
        name="stuffWriteOffNeeded"
        form={filtersForm}
        options={stuffWriteOptions}
      />
      <Control.Select
        label={i18n.t('SLAStandard')}
        name="expired"
        form={filtersForm}
        options={slaOptions}
      />
      <Control.Employees
        label={i18n.t('Performers')}
        name="assignees"
        form={filtersForm}
        multiple
      />
      <Control.MultipleSelect
        label={i18n.t('Rating')}
        name="rates"
        form={filtersForm}
        options={rateOptions}
      />
      <Styled.Checkboxes>
        <Control.Checkbox
          label={i18n.t('HavingUnreadMessages')}
          name="isUnreadMessage"
          form={filtersForm}
        />
        <Control.Checkbox
          label={i18n.t('HasRelatedTicketsFilter')}
          name="hasRelated"
          form={filtersForm}
        />
      </Styled.Checkboxes>
    </FiltersTemplate>
  );
};
